import { ChangeDetectionStrategy, ChangeDetectorRef, Component, Inject, Input, OnChanges, Optional, SimpleChanges } from '@angular/core';
import { Grid } from '@app/core/components/grid/grid.model';
import { GridOptions } from '@app/core/components/grid/grid.types';
import { ModalService } from '@app/core/services/modal.service';
import { TranslateService } from '@app/core/services/translate.service';
import { TT_VIEW_NAVIGATOR, TTViewNavigator } from '@app/modal/state-modal/state-modal.component';
import { CustactGet } from '@app/services/custact.service';
import { CustactEditComponent } from '../../custact-edit/custact-edit.component';
import { CustactDialogsComponent } from '../../custact-dialogs/custact-dialogs.component';

@Component({
    selector: 'tt-work-details-desktop',
    templateUrl: './work-details-desktop.component.html',
    styleUrls: ['./work-details-desktop.component.css'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WorkDetailsDesktopComponent implements OnChanges {
    @Input()
    public params?: CustactGet;

    public emailGridLoaded = false;

    public documentsGridLoaded = false;

    public subtasksGridLoaded = false;

    public subtasksGrid: GridOptions = new Grid()
        .setRememberId('workdetails_custact_subtasks_grid')
        .setLoadDataFunction({ method: 2974, parameters: () => ({ custact_no: this.params?.custact_no, retrievetype: 'child', include_top: '0' }) })
        .addToolbarButton({
            name: 'workdetails_new_subtask',
            text: 'workdetails_new_subtask',
            translate: true,
            icon: 'fa-plus',
            cssClass: 'tt-button tt-button--primary im-grid-btn-xs-r',
            func: async () => {
                await this.modal.openStateDialog({ state: 'custactedit', params: `0/custact_no/${this.params?.custact_no}` });
                this.subtasksGrid?.gridfunc?.read(false);
            },
        });

    public participantsGridLoaded = false;

    public participantsGrid: GridOptions = new Grid().setRememberId('custact_members_grid').setLoadDataFunction({ method: 2975, parameters: () => ({ custact_no: this.params?.custact_no }) });

    public powtimesGridLoaded = false;

    constructor(
        private modal: ModalService,
        private cdr: ChangeDetectorRef,
        translate: TranslateService,
        @Optional() @Inject(TT_VIEW_NAVIGATOR) public navigator?: TTViewNavigator,
    ) {
        translate.translated$.subscribe({ next: () => this.cdr.markForCheck() });
    }

    public async onCustactSubmit(edit: CustactEditComponent, dialogs?: CustactDialogsComponent) {
        await Promise.all([dialogs?.loadGet(), edit.loadGet()]);
        this.cdr.markForCheck();
    }

    public onTabSelected(id: string) {
        if (id === 'EMAIL') {
            this.emailGridLoaded = true;
        } else if (id === 'DOCUMENTS') {
            this.documentsGridLoaded = true;
        } else if (id === 'SUBTASKS') {
            this.subtasksGridLoaded = true;
        } else if (id === 'CUSTACTMEMBERS') {
            this.participantsGridLoaded = true;
        } else if (id === 'POWTIMES') {
            this.powtimesGridLoaded = true;
        }

        this.markForChange();
    }

    public markForChange() {
        this.cdr.markForCheck();
        this.cdr.detectChanges();
        setTimeout(() => {
            this.cdr.markForCheck();
            this.cdr.detectChanges();
        });
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (!!changes['params'].currentValue) {
            this.onTabSelected(changes['params'].currentValue.bg_tab1);
        }
    }
}
